import { Injectable } from '@angular/core';

/*
  Generated class for the AlertServiceProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class EnkripsiProvider {

  constructor(

  ) {

  }

  getEncode(message: string, length: number): Promise<any> {
    var lengthCode = message.length;
    var awal = 0;
    var akhir = length;
    var hasil = '';
    for (var i = 0; i < lengthCode; i += length) {
      hasil += message.substring(awal, akhir).split("").reverse().join("");
      awal += length;
      akhir += length;
    }
    return Promise.resolve(hasil);
  }

}



// WEBPACK FOOTER //
// ./src/providers/enkripsi/enkripsi.ts